import { render, staticRenderFns } from "./FormNumber.vue?vue&type=template&id=a0fb1b98&"
import script from "./FormNumber.vue?vue&type=script&lang=js&"
export * from "./FormNumber.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports